/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import { GetComplianceStatusResponse } from "~/features/userGuide/types";

const UserGuideApi = {
  getComplianceStatus: () => ApiCaller.get<GetComplianceStatusResponse>("/v1/resellercompliance/resellerstatus"),
};

export default UserGuideApi;
